import React from "react";
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import GenericInput, { IGenericInputState, IGenericInputProps } from "./GenericInput";

export interface IPasswordInputState extends IGenericInputState {
  showPassword: boolean;
};

class PasswordInput extends GenericInput {
  state: IPasswordInputState = {
    active: false,
    showPassword: false
  };

  constructor(props: Readonly<IGenericInputProps> | IGenericInputProps) {
    super(props);
    this.onToggleClick = this.onToggleClick.bind(this);
    this.onToggleMouseDown = this.onToggleMouseDown.bind(this);
  };

  renderInputElement(): React.ReactNode {
    return (
      <Input
        id={this.inputId}
        type={this.state.showPassword ? 'text' : 'password'}
        autoFocus={this.props.autoFocus}
        value={this.props.value}
        name="password"
        onChange={this.handleChangeEvent}
        onKeyDown={this.props.onKeyDown}
        onFocus={this.handleFocusEvent}
        onBlur={this.handleBlurEvent}
        disabled={this.props.disabled || this.props.loading}
        endAdornment={this.renderRightElement()}
        startAdornment={this.renderLeftElement()}
      />
    );
  }

  onToggleClick(event: React.MouseEvent<HTMLButtonElement>) {
    this.setState(Object.assign({}, this.state, { showPassword: !this.state.showPassword }));
  }

  onToggleMouseDown(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
  }

  renderRightElement(): React.ReactNode {
    const toggleButton = <IconButton aria-label="Toggle Password Visibility" onClick={this.onToggleClick} onMouseDown={this.onToggleMouseDown} edge="end">
      {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
    </IconButton>;
    const element = this.props.right ? <div>{this.props.right}{toggleButton}</div> : toggleButton;
    return (<InputAdornment position="end">{element}</InputAdornment>);
  }

}

export default PasswordInput;